import { createSelector } from 'reselect';

import { RootState } from 'app/store';

import { RequestStatus } from 'constants/enums';

export const selectApplications = (state: RootState) =>
  state.applications.applications;

export const selectApplicationsFacets = (state: RootState) =>
  state.applications.facets;

export const selectApplicationsDetails = (state: RootState) => {
  return state.applications;
};

export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;

export const selectActiveApplication = createSelector(
  [selectApplications, selectActiveUserId],
  (applications, activeApplicationId) =>
    applications.find((application) => application.id === activeApplicationId)
);

export const selectRequestStatus = (state: RootState) =>
  state.applications.status;

export const selectIsLoading = (state: RootState) =>
  state.applications.status === RequestStatus.Loading ||
  state.applications.status === RequestStatus.Idle;

export const selectDashboardApplications = (state: RootState) =>
  state.applications.dashboardApplications;

export const selectIsDashboardApplicationsLoading = (state: RootState) =>
  state.applications.isDashboardApplicationsLoading;

export const selectActiveApplicationDetails = (state: RootState) =>
  state.applications.activeApplicationDetails;
